// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_WORKER_NAME_TEAMHEAD } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

export interface Worker {
  id: number;
  fullName: string;
  role: string;
  level: number;
  ProjectCode :string;
  hour:number;
}
const api = new APIClient();

interface Workers {
  workers: Worker[];
}

let val: Workers;

const useFetchDataWorkers = () => {
  const [workers, setData] = useState(val);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_WORKER_NAME_TEAMHEAD, null)
          .then((response) => {
            setData(JSON.parse(JSON.stringify(response)));
            setLoading(false);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return {
    workers,
    loading,
  };
};

export default useFetchDataWorkers;
